import { useEffect } from "react";
import { createPortal } from "react-dom";
import { STATUS, FLAG } from "@/lib/api";

export const Chip = ({ cls, label, style, testId }) => (
  <span className={`chip ${cls}`} style={style} data-testid={testId}><span className="dot" />{label}</span>
);

export const StatusChip = ({ status, style, testId }) => {
  const [cls, label] = STATUS[status] ?? ["gray", status];
  return <Chip cls={cls} label={label} style={style} testId={testId} />;
};

export const FlagChip = ({ flag, style, testId }) => {
  const [cls, label] = FLAG[flag ?? "on_track"] ?? FLAG.on_track;
  return <Chip cls={cls} label={label} style={style} testId={testId} />;
};

export const Modal = ({ title, sub, onClose, children, testId, wide }) => {
  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") onClose?.(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);
  return createPortal(
    <div className="modal-bg" onClick={onClose} data-testid="modal-backdrop">
      <div className={`modal ${wide ? "wide" : ""}`} onClick={(e) => e.stopPropagation()} data-testid={testId || "modal"}>
        <h2>{title}</h2>
        {sub && <div className="sub">{sub}</div>}
        {children}
      </div>
    </div>,
    document.body
  );
};

export const Empty = ({ children }) => <div className="empty" data-testid="empty-state">{children}</div>;
